export function parseBRL(value) {
  return parseFloat(value.replace(/\./g, '').replace(',', '.')) || 0;
}

/** Preço digitado à mão. O teclado decimal entrega vírgula ou ponto conforme o
 *  aparelho e o idioma do teclado, e o usuário não deveria ter que reparar
 *  nisso: com vírgula presente ela é o separador decimal e os pontos são de
 *  milhar; sem vírgula, o ponto é o decimal. Devolve NaN no que não for
 *  número, e quem chama decide o que fazer. */
export function parseDecimalInput(value) {
  if (typeof value !== 'string') return Number(value);
  const trimmed = value.trim();
  if (!trimmed) return NaN;
  const normalized = trimmed.includes(',')
    ? trimmed.replace(/\./g, '').replace(',', '.')
    : trimmed;
  return Number(normalized);
}

/** Sem `type="number"` o campo aceitaria letras: mantém só dígitos e um
 *  separador decimal. */
export function sanitizeDecimalInput(value) {
  return value.replace(/[^\d.,]/g, '');
}

export function formatBRL(value) {
  return `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
